export const PARTS_OF_DAY = [
  { title: "Ponoć", value: "ponoc" },
  { title: "Pre podne", value: "pre podne" },
  { title: "Posle podne", value: "posle podne" },
];

export const CITIES = [
  { title: "Novi Pazar", value: '"Novi Pazar"' },
  { title: "Tutin", value: "Tutin" },
  { title: "Beograd", value: "Beograd" },
  { title: "Niš", value: "Niš" },
  { title: "Sjenica", value: "Sjenica" },
];

export const CONTACT_TYPES = [
  { title: "DIR", value: 1 },
  { title: "DIR/I", value: 2 },
  { title: "WCP", value: 3 },
  { title: "WCP/I", value: 4 },
  { title: "VIB", value: 5 },
  { title: "VIB/I", value: 6 },
  { title: "Ostalo", value: 7 },
];

export const TRAVEL_TYPES = [
  { title: "Let", value: 1 },
  { title: "Adresa", value: 2 },
];
